import { ApiError } from "../services/api-error";

type T = (key: string, options?: Record<string, unknown>) => string;

/** A readable message for the scheduling errors of the server, else the server's own text. */
export function bookingSaveError(error: unknown, t: T, isAdmin: boolean): string {
  if (error instanceof ApiError) {
    if (error.code === "vessel_busy") {
      const d = (error.details ?? {}) as { tripName?: string; from?: string; to?: string };
      return t(isAdmin ? "slotScheduling.vesselBusyAdmin" : "slotScheduling.vesselBusy", {
        trip: d.tripName ?? t("slotScheduling.conflictFallback"),
        from: d.from ?? "",
        to: d.to ?? "",
      });
    }
    if (error.status === 403 && !isAdmin) return t("slotScheduling.adminOnlyTrip");
  }
  return (error as Error).message;
}
